import React, { useState } from 'react'
import { format } from 'date-fns'
import {
  Button,
  Form,
  List
} from 'semantic-ui-react'
import filter from 'lodash/filter'
// Local
import {
  FORMAT,
  shouldRenderReskin2025
} from '../../../constant'
import { EncounterNoteRow } from '../../authenticated/types'
import If from '../../common/if'
import ReveleerButton from '../../common/ReveleerButton'

type Props = {
  encounterId: string
  onSubmit: (
    noteID: string,
    noteBody: string
  ) => void
  notes: EncounterNoteRow[] | null | undefined
}

function EncounterNotes(
  props: Props
): JSX.Element {
  const {
    encounterId,
    onSubmit,
    notes: notesProp
  } = props

  const [
    noteState,
    setNoteState
  ] = useState<string>('')

  const onChange = (value: string) => {
    setNoteState(value)
  }

  const notes = filter(
    notesProp,
    { encounterConditionId: null }
  )

  const shouldItalicizePlaceholder = shouldRenderReskin2025
    ? ' italicize'
    : ''

  return (
    <div>
      <div
        role="list"
        className="ui divided list"
      >
        <If isTrue={ !!notes }>
          {
            notes.map(note => (
              <List.Item key={ note.id }>
                <div className="m-1-top m-1-bottom">
                  <span>
                    {
                      format(
                        note.creationDate,
                        FORMAT.DATE_TIME
                      )
                    }
                  </span>
                  <span>
                    {` - ${ note.createdByUserName } - `}
                  </span>
                  <span className="italic">
                    &quot;{ note.noteBody }&quot;
                  </span>
                </div>
              </List.Item>
            ))
          }
        </If>
      </div>
      <Form.TextArea
        name="note"
        value={ noteState }
        className={ `condition-notes-textarea${shouldItalicizePlaceholder}` }
        placeholder="Encounter Notes: Only Viewable by CDI and Coder Users."
        onChange={
          (
            event: any,
            { value }: { value: string }
          ) => onChange(value)
        }
      />
      <If isTrue={ !!noteState && !!noteState.length }>
        <div>
          <If isTrue={ !shouldRenderReskin2025 }>
            <Button
              id="encounter-notes-add-note"
              color="blue"
              type="submit"
              onClick={ () => {
                onSubmit(
                  encounterId,
                  noteState
                )
              } }
            >
              Add Note
            </Button>
          </If>
          <If isTrue={ shouldRenderReskin2025 }>
            <ReveleerButton
              buttonLabel="Add Note"
              buttonSize="small"
              buttonType="primary"
              id="encounter-notes-add-note"
              isDisabled={ false }
              onClick={ () => {
                onSubmit(
                  encounterId,
                  noteState
                )
              } }
              type="submit"
            />
          </If>
        </div>
      </If>
    </div>
  )
}

export default EncounterNotes
